'use client';

import dynamic from 'next/dynamic';
import type { ComponentType } from 'react';
import { useFunnelInterrupt } from './Context';
import type { InterruptId } from './types';

/**
 * UI registry only. Keep modal loaders here (or a sibling registry), not in config.ts.
 * config.ts should stay free of React so matchers, navigation, and tests can import
 * it without pulling client UI into that graph.
 */
const INTERRUPT_MODALS: Record<InterruptId, ComponentType> = {
  branch_correction: dynamic(
    () =>
      import('./modals/CreditScoreBranchCorrectionModal').then(mod => ({
        default: mod.CreditScoreBranchCorrectionModal,
      })),
    { loading: () => null },
  ),
};

export function InterruptHost() {
  const { activeInterruptId } = useFunnelInterrupt();
  if (!activeInterruptId) return null;

  const Modal = INTERRUPT_MODALS[activeInterruptId];
  return <Modal />;
}
